/**
 * Analisis del retorno de OAuth en la URL.
 *
 * Vive en su propio modulo, sin React, por dos motivos: se prueba sin montar la
 * aplicacion, y `AuthProvider.tsx` debe exportar solo componentes y hooks
 * (regla `react-refresh/only-export-components`).
 *
 * Existe por una regresion real (17/08/2026): con una clave de API invalida el
 * canje de PKCE respondia 401, `supabase-js` dejaba el `?code=` en la URL sin
 * lanzar ningun error, y la aplicacion volvia muda a la pantalla de inicio de
 * sesion. Un fallo silencioso es peor que un fallo ruidoso
 * (docs/UI_UX_SPEC.md: todo estado se explica).
 */

/**
 * Devuelve un mensaje explicativo si la URL delata un retorno de OAuth que no
 * llego a convertirse en sesion, o `null` si no hay nada que decir.
 *
 * Solo tiene sentido llamarla cuando ya se sabe que **no** hay sesion: cuando
 * el canje prospera, `supabase-js` limpia el `?code=` de la URL.
 *
 * Nunca incluye el codigo de autorizacion en el mensaje.
 */
export function describeOAuthCallback(search: string): string | null {
  const params = new URLSearchParams(search);

  const proveedor = params.get('error_description') ?? params.get('error');
  if (proveedor !== null && proveedor !== '') {
    return `El proveedor de identidad devolvio un error: ${proveedor}`;
  }

  if (params.has('code')) {
    return (
      'Google devolvio un codigo de autorizacion, pero no se pudo canjear por una sesion. ' +
      'Suele deberse a VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY incorrectas. ' +
      'Revisa la consola: un 401 en /auth/v1/token lo confirma.'
    );
  }

  return null;
}
